import React from "react";

function PassCover({ color }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 755.45 217.99">
      <title>Asset 5</title>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            fill={color || "#343434"}
            d="M111.1,133.14a61.28,61.28,0,0,1-22.5,4.22q-14.76,0-26.14-6.44a44.23,44.23,0,0,1-17.58-18.17q-6.21-11.72-6.21-27t6.21-26.95A44.29,44.29,0,0,1,62.46,40.67q11.37-6.45,26.14-6.45a52.7,52.7,0,0,1,37.74,15L150,25.55Q124,0,87.66,0,62.11,0,42.19,10.66A76.64,76.64,0,0,0,11.13,40.9Q0,60.48,0,85.79t10.9,44.77A75.93,75.93,0,0,0,41.84,160.8q20,10.78,46.53,10.78,37.5,0,64-25.55L129.86,121A54,54,0,0,1,111.1,133.14Z"
          />
          <rect
            fill={color || "#343434"}
            x="570.51"
            y="3.76"
            width="36.8"
            height="164.08"
          />
          <polygon
            fill={color || "#343434"}
            points="715.6 52.04 700.84 88.61 687.24 126.35 674.58 88.61 661.22 52.04 621.61 52.04 666.61 166.19 644.11 217.99 683.26 217.99 755.45 52.04 715.6 52.04"
          />
          <path
            fill={color || "#343434"}
            d="M382.06,49.46Q364,49.46,353,63.94V52H316.2V167.83H353V111.57q0-14.53,6.8-22T378.32,82a28,28,0,0,1,8.91,1.41,44.52,44.52,0,0,1,9.14,4.46l15.47-27A39.29,39.29,0,0,0,398,52.4,45.92,45.92,0,0,0,382.06,49.46Z"
          />
          <path
            fill={color || "#343434"}
            d="M256.66,52h-4.45V63.47a46.8,46.8,0,0,0-14.77-9.67,55.58,55.58,0,0,0-21.56-4.1q-16.17,0-28.71,7.62A52.27,52.27,0,0,0,167.6,78.65q-7,13.71-7,31.29t7,31.29a52.27,52.27,0,0,0,19.57,21.33q12.54,7.62,28.71,7.62,22,0,36.33-14v11.66H289V52H256.66Zm-12.19,79.11q-7.74,8.08-19.92,8.09T204.74,131q-7.62-8.2-7.62-21.1t7.62-21.09q7.62-8.2,19.81-8.2t19.92,8.09q7.74,8.08,7.73,21.21T244.47,131.15Z"
          />
          <path
            fill={color || "#343434"}
            d="M506.29,3.76h-.47v59.3Q491.29,49.69,470,49.7q-16.17,0-28.71,7.62a52.27,52.27,0,0,0-19.57,21.33q-7,13.71-7,31.29t7,31.29a52.27,52.27,0,0,0,19.57,21.33q12.54,7.62,28.71,7.62,22,0,36.33-14v11.65H543.1V3.76H506.29Zm-7.74,127.39q-7.74,8.08-19.92,8.09T458.82,131q-7.62-8.2-7.62-21.1t7.62-21.09q7.62-8.2,19.81-8.2t19.92,8.09q7.74,8.08,7.73,21.21T498.55,131.15Z"
          />
        </g>
      </g>
    </svg>
  );
}

export default PassCover;
